export function noValue(val: string) {
  return val ?? '-'
}
